/* Maps each PHP version to its static-asset runtime URLs on Cloudflare Pages.
 *
 * The version DATA (labels, tags, sizes) lives in src/data/php-versions.ts; this
 * module owns only the URL convention so call sites never hand-build paths. Each
 * version ships as two same-origin static assets under /wasm/<version>/ (emitted
 * by scripts/build-wasm-runtime.mjs from the npm @php-wasm/web-<ver> packages):
 *   - php-loader.mjs : the esbuild-bundled Emscripten loader (small)
 *   - php_<M>_<m>.wasm : the PHP runtime binary (~15–22 MiB), streaming-compiled
 *
 * The .wasm filename mirrors the upstream package (php_8_4.wasm, php_8_3.wasm …),
 * so the worker resolves it via the loader's own locateFile and the cache manager
 * addresses it directly for measure/remove. */

import { PHP_VERSIONS } from '../data/php-versions';

/** "8.4" → "8_4" (npm package / wasm filename convention). */
function underscore(version: string): string {
  return version.replace('.', '_');
}

/** URL of the runtime loader module the worker dynamically imports. */
export function runtimeUrl(version: string): string {
  return `/wasm/${version}/php-loader.mjs`;
}

/** URL of the version's .wasm binary (what actually consumes cache quota). */
export function wasmUrl(version: string): string {
  return `/wasm/${version}/php_${underscore(version)}.wasm`;
}

/** Both static assets a version needs to run offline, loader first (small). */
export function runtimeAssets(version: string): string[] {
  return [runtimeUrl(version), wasmUrl(version)];
}

/** Every shippable version key, in canonical (newest-first) registry order. */
export const ALL_VERSIONS: string[] = PHP_VERSIONS.map((v) => v.v);
